import { CountMetric, EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'
import { AtCoreServiceClient } from '@api/AtCoreServiceClient'

/**
 * Get active user information.
 * @returns {promise}   Promise resolves with an object containing active user information.
 *                      ASSET stores are not supported yet. Promise will be rejected.
 *                      {
 *                          userAlias: "ohuerta"
 *                      }
 *                      If there is an error it rejects with the error.
 */
export const getUserInfo = (): Promise<any> => {
    const storeId = EnvironmentDetail.getStoreId()
    return getUserInfoFromCoreService(storeId)
}

/**
 * Get active user information.
 * @returns {promise} Promise resolves with an object containing active user information.
 * Note: Not supported for 3P users.
 */
export const getUserInformation = (): Promise<any> => {
    // StoreId is available immediately after user login in environmentDetailService.
    // Does not check if store if supported or not.
    const storeId = EnvironmentDetail.getStoreId()
    return getUserInfoFromCoreService(storeId)
}

const getUserInfoFromCoreService = (storeId: string) => {
    const faultMetric = new CountMetric(undefined, 'Fault', 'IhmFlyingDutchman', 'UserInfoService.getUserInfoFromCoreService')
    return AtCoreServiceClient.getInstance().getUserAlias(storeId)
        .then((response) => {
            faultMetric.count(0)
            return response.body ? response.body : response
        })
        .catch((error) => {
            console.error('ATBase: Error detected when calling getUserAlias in coreService: ', JSON.stringify(error))
            faultMetric.count(1)
            return Promise.reject(error)
        })
}
